/* RESPONSIBLE TEAM: team-channels */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from 'embercom/objects/inbox/admin-summary';
import { type Block } from '@intercom/interblocks.ts';

interface MergedPrimaryConversationWireFormat {
  admin_summary: AdminSummaryWireFormat;
  user_id: string;
  blocks: Array<Block>;
  user_display_name: string;
  merged_conversation_subject: string;
  merged_conversation_id: number;
}

export default class MergedPrimaryConversation implements RenderableData {
  renderableType: RenderableType = RenderableType.MergedPrimaryConversation;
  readonly adminSummary: AdminSummary;
  readonly userId: string;
  readonly blocks: Array<Block>;
  readonly userDisplayName: string;
  readonly mergedConversationSubject: string;
  readonly mergedConversationId: number;

  get creatingEntity() {
    return {
      type: EntityType.Admin,
      id: this.adminSummary.id,
    };
  }

  constructor(
    adminSummary: AdminSummary,
    userId: string,
    blocks: Array<Block>,
    userDisplayName: string,
    mergedConversationSubject: string,
    mergedConversationId: number,
  ) {
    this.adminSummary = adminSummary;
    this.userId = userId;
    this.blocks = blocks;
    this.userDisplayName = userDisplayName;
    this.mergedConversationSubject = mergedConversationSubject;
    this.mergedConversationId = mergedConversationId;
  }

  static deserialize(json: MergedPrimaryConversationWireFormat): MergedPrimaryConversation {
    return new MergedPrimaryConversation(
      AdminSummary.deserialize(json.admin_summary),
      json.user_id,
      json.blocks,
      json.user_display_name,
      json.merged_conversation_subject,
      json.merged_conversation_id,
    );
  }
}
